/*
 * File: 客户模块-客户系
 */
<template>
    <div class="customer-series-manage">
        <Paper class="customer-series-manage-paper">
            <el-tabs class="customer-series-manage-tab-pane" v-model="activeTabs" @tab-remove="removeTab" @tab-click="switchTabs">
                <!-- 合同列表页 -->
                <el-tab-pane label="客户系列表" name="theList" ref="myPane">
                    <list-layout-paper>
                        <template slot="header-search" class="searchBox">
                            <search-box
                                ref="searchBox"
                                :search-key="config.name"
                                :fields="config.searchFields"
                                :showResetBtn="true"
                                @search-change="contractList.searchList"
                            />
                        </template>
                        <template slot="header-button">
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="属地客户经理导入"
                                icon="el-icon-upload2"
                                v-has="authorityCode.localCustomerManagerImport"
                                @click="handleImport"
                            >属地客户经理导入</lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="刷新"
                                @click="refresh"
                                plain>
                                <span class="icon iconfont icon-refresh"></span>
                            </lotsButton>
                            <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                                <el-button
                                icon="iconfont icon-list_install"
                                type="primary"
                                size="mini"
                                :title="'列配置'"
                                @click="showColumnConfigDialog"
                                plain />
                            </el-tooltip>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <table-box
                                ref="clientOrder"
                                :height="tableHeight"
                                v-loading="contractList.tableLoading"
                                :selection="config.selection"
                                :index="config.index"
                                :columns="config.tableData.columns"
                                :rows="contractList.totalData"
                                @row-dblclick="(row) => rowDBclick(row)">
                                <template v-slot:col-append="{ col, row }">
                                    <div v-if="col.prop === 'businessType'">{{col.prop === 'businessType' ? row.busiLabelList:row.businessType}}</div>
                                    <el-button v-if="col.prop === 'currentQuarterCount'" type="text"  @click.stop="handleOnePage(row, 'currentQuarterCount')">{{ row.currentQuarterCount }}</el-button>
                                    <el-button v-if="col.prop === 'totalHistoryCount'" type="text"  @click.stop="handleOnePage(row, 'totalHistoryCount')">{{ row.totalHistoryCount }}</el-button>
                                </template>
                            </table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                @size-change="contractList.sizeChange"
                                :current-page.sync="contractList.pageNo"
                                @current-change="contractList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="contractList.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>
                <!-- 详情页签 -->
                <el-tab-pane
                    class="detail-pane"
                    closable
                    :class="item.code"
                    v-for="item in tabList"
                    :key="item.code"
                    :label="item.name"
                    :name="item.code">
                    <detail-page
                        :ref="`datailTabs${item.code}`"
                        :key="item.code"
                        :detailData="item.detailData"
                    />
                </el-tab-pane>
            </el-tabs>
            <!-- 导入弹窗 -->
            <addFileDialog
                ref="fileDialogRef"
                :config="config.importConfig"
                @uploadSuccessHandle="contractList.getList()"
                @uploadFailHandle="contractList.getList()"
            />
            <!-- 表格列配置弹框 -->
            <column-config
                ref="otpColumnConfig"
                :pageID="config.name"
                :initColumns="config.tableData.columns"
                @header-change="config.tableData.columns = $event"
            />

            <OnePaperListDialog ref="onePaperListDialogRef" />
        </Paper>
    </div>
</template>
<script>
import { ref, reactive, onMounted, getCurrentInstance } from '@vue/composition-api';
import { Message } from 'element-ui';
import _ from 'lodash';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import { getCustomerGroupInfoPage } from '@mdm/api/customer/customerSeries.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import utils from '@/components/utils/common.js';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import store from '@/store';
import OnePaperListDialog from './component/onePaperListDialog.vue';
import detailPage from './detail/Detail.vue';

export default {
    name: 'customer',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        lotsPagination,
        lotsButton,
        columnConfig,
        addFileDialog,
        OnePaperListDialog,
        detailPage
    },
    props: {},
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const { user } = store.getters;
        const config = reactive(configStatic);
        const authorityCode = reactive(btnAuthority.customerSeries);
        const activeTabs = ref('theList');
        const tabList = ref([]); // 打开的详情tab页集
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this

        class ContractListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map((v) => ({
                        ...v,
                        currentQuarterCount: v.currentQuarterCount || 0,
                        totalHistoryCount: v.totalHistoryCount || 0
                    }));
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const contractList = new ContractListClass({
            Api: {
                listApi: getCustomerGroupInfoPage // 查询接口
            }
        });
        const removeTab = (targetName) => { // 删除详情标签
            if (activeTabs.value === targetName) {
                activeTabs.value = 'theList';
                jumpToDetail();
            }
            tabList.value = tabList.value.filter(
                (tab) => tab.code !== targetName
            );
        };
        const switchTabs = (data) => {
            if (data.name !== 'theList') {
                const currentTab = tabList.value[Number(data.index) - 1];
                if (currentTab.code === ctx.$route.query.customerGroupCode) return;
                jumpToDetail({ customerGroupCode: currentTab.code });
            } else {
                jumpToDetail();
            }
        };
        const refresh = () => {
            contractList.getList();
        };
        const searchDataFormat = (condition) => {
            if (condition.createTime && condition.createTime.length) {
                condition.startTime = utils.formatDateTime(condition.createTime[0]);
                condition.endTime = utils.formatDateTime(condition.createTime[1]);
                Reflect.deleteProperty(condition, 'createTime');
            }
            if (condition.selectList && condition.selectList.length) {
                condition.crmUserCodes = condition.selectList[0].userCode;
            }
            Reflect.deleteProperty(condition, 'selectList');
            Reflect.deleteProperty(condition, 'userName');
            condition.userCode = user.userCode;
            condition.isNew = condition.isNew ? +condition.isNew : null;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return condition;
        };
        // 导入
        const handleImport = () => {
            setupContext.refs.fileDialogRef.openImport();
        };
        // 列配置
        const showColumnConfigDialog = () => {
            setupContext.refs.otpColumnConfig.show(true);
        };
        // 查看客户一页纸
        const handleOnePage = (row, type) => {
            if (!row[type]) return;
            setupContext.refs.onePaperListDialogRef.show({ ...row, queryType: type === 'currentQuarterCount' ? 0 : 1 });
        };
        // 跳转至详情
        const jumpToDetail = (query = {}) => {
            ctx.$router.replace({ path: '/mod/mdm/customer-series', query });
        };
        // 双击表格
        const rowDBclick = (row) => {
            if (row.customerGroupCode === '00') {
                Message.warning('请在客户详情页维护属地客户经理');
                return;
            }
            // 滚动到顶部
            const element = document.getElementsByClassName('app-main');
            element[0].scrollTo(0, 0);
            const data = _.cloneDeep(row); // 深拷贝是防止表格源数据被修改
            newDetailPage(row.customerGroupCode, data, row.customerGroupName);
        };
        const newDetailPage = (code, data, name) => {
            const judge = tabList.value.filter((item) => item.code === code);
            if (judge.length === 0 && tabList.value.length === 8) {
                Message.warning('已超出8个详情页，请关闭后重新打开');
            } else {
                const dataGather = {
                    name,
                    code,
                    detailData: _.cloneDeep(data)
                };
                // 新增判断页签数据调整
                if (judge.length === 0) {
                    // 第一次打开
                    tabList.value.push(dataGather);
                }
                // 编辑时更新当前数据- 新增的页签替换成查看详情
                const _index = tabList.value.findIndex((item) => item.code === code);
                if (_index > -1 && !_.isEqual(data, tabList.value[_index].detailData)) {
                    tabList.value[_index] = dataGather;
                }
                activeTabs.value = code; // tabs切换到对应详情页

                if (code === ctx.$route.query.customerGroupCode) return;
                jumpToDetail({ customerGroupCode: code });
            }
        };
        // 获取详情
        const handleDetail = async (customerGroupCode) => {
            const params = {
                pageNo: 1,
                pageSize: 10,
                userCode: user.userCode,
                customerGroupCode
            };
            return getCustomerGroupInfoPage(params).then(res => {
                if (res && +res.code === 0 && res.data?.list) {
                    rowDBclick(res.data.list[0]);
                }
            });
        };
        onMounted(async () => {
            setupContext.refs.searchBox.submitSearch();

            // 初始化页面时路由参数存在customerGroupCode
            if (ctx.$route.query.customerGroupCode) {
                try {
                    await handleDetail(ctx.$route.query.customerGroupCode);
                    // eslint-disable-next-line no-empty
                } catch (error) {
                }
            }
        });
        return {
            config,
            authorityCode,
            tabList,
            activeTabs,
            removeTab,
            switchTabs,
            contractList,
            searchDataFormat,
            refresh,
            handleImport,
            showColumnConfigDialog,
            handleOnePage,
            rowDBclick
        };
    }
};
</script>

<style lang="less">
.customer-series-manage {
    width: 100%;
    .customer-series-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .customer-series-manage-tab-pane {
        width: 100%;
        height: 100%;

        & > .el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            & > .el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .el-tabs {
        width: 100%;
    }
    .flex-layout .list-main {
        overflow: auto;
    }
    .flex-layout .table {
        overflow-y: auto;
    }
    .layout-content.customer-series-manage-paper {
        padding: 0 20px 20px;
    }
    .list-layout-wrapper {
        padding: 0;
    }
    .col-append-box {
        display: flex;
        align-items: center;
        .col-append-btn {
            padding-bottom: 3px;
            padding-left: 3px;
            .eye-btn {
                display: inline-block;
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
    }
}
</style>
